const KEY = "bizaclia:vip-invitation";
export const VIP_INVITATION_EVENT = "bizaclia:vip-invitation-ready";
// Ventana corta: una invitación abandonada no debe activarse en un login
// posterior sin relación con ella.
const MAX_AGE = 30 * 60 * 1000;
type InvitationIntent = { email: string; createdAt: number };
let memoryIntent: InvitationIntent | null = null;

export function rememberVipInvitation(email: string) {
  memoryIntent = {
    email: email.trim().toLowerCase(),
    createdAt: Date.now(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(memoryIntent));
  } catch {
    /* Current-tab fallback. */
  }
  window.dispatchEvent(new Event(VIP_INVITATION_EVENT));
}

export function readVipInvitation(): InvitationIntent | null {
  let intent: InvitationIntent | null = memoryIntent;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) intent = JSON.parse(stored);
  } catch {
    /* Storage may be disabled. */
  }
  if (
    !intent ||
    typeof intent.email !== "string" ||
    typeof intent.createdAt !== "number" ||
    Date.now() - intent.createdAt > MAX_AGE ||
    intent.createdAt > Date.now()
  )
    return null;
  return intent;
}

export function clearVipInvitation() {
  memoryIntent = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* Storage may be disabled. */
  }
}
